module.exports = __webpack_public_path__ + "img/newlook.88c8f2a7.png";